/** 画面をまたいで使う小さな部品。 */
import { sourceLabel } from "../format";

export function SourceBadge({ source }: { source: string | null }) {
  const l = sourceLabel(source);
  return <span className={`badge tone-${l.tone}`}>{l.text}</span>;
}

export function StateChip({ state, label }: { state: string; label: string }) {
  return <span className={`chip state-${state}`}>{label}</span>;
}
